module.exports = __webpack_public_path__ + "img/logo-ding.7c0e7480.png";